<template>

    <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

    <!-- search layer -->
    <!-- <div class="grey lighten-4">
        <div class="container section"></div>
    </div> -->

    <!-- breadcrumbs -->
    <nav class="grey lighten-4 z-depth-0">
      <div class="container nav-wrapper">
        <div class="col s12">
          <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
          <router-link to="/care/billing" class="breadcrumb blue-grey-text text-darken-3"><small> Billing Home</small></router-link>
          <span class="breadcrumb blue-grey-text pointable"><small>Review</small></span>
        </div>
      </div>
    </nav>


    <!-- main -->
    <div id="top"></div>

    <div class="container">

        <LoadingDiv v-if="!isReady" />

        <template v-else>
            <br />

            <!-- Success -->
            <SubmitSummary :cluster="success" @cancel="handleCancel" v-if="success" />

            <!-- Main Displays  -->
            <div id="mid-top"></div>
            <template v-if="cluster">
                <div class="card z-depth-0 grey lighten-4">
                    <br />
                    <span class="new badge left" data-badge-caption="Scheme">
                        {{ cluster.scheme.name.toUpperCase() }}
                    </span>
                    <div class="card-content">
                        <span class="card-title black-text">
                            <span class="card-title">
                                <i class="small material-icons blue-grey-text text-darken-2 chip white pointable left hide-on-small-only"
                                    title="claims detail">bookmark</i>{{ HMO }}

                                <span class="secondary-content"><a href="#"
                                        class="teal-text text-darken-1 dropdown-trigger right" data-target="dropmenu"><i
                                            class="small material-icons" title="review">more_vert</i></a></span>

                                <span class="chip"> <b>{{ cluster.month.name }} {{ cluster.year.name }}
                                        Claims</b></span>

                                <span class="chip yellow lighten-2" v-if="cluster.status === 'q'">
                                    <b>Unsubmitted</b></span>
                                <span class="chip blue lighten-2" v-if="cluster.status === 'p'">
                                    <b>Submitted</b></span>
                                <span class="chip teal lighten-2" v-if="cluster.status === 'v'">
                                    <b>Completed</b></span>

                            </span>


                            <ul id="dropmenu" class="dropdown-content">
                                <li @click.prevent="handleReview('view')">
                                    <a href="#">View All Pages <b>({{ encounters?.length ? encounters.length : 0
                                            }})</b></a>
                                </li>

                                <li class="divider" tabindex="-1"></li>
                                <li @click.prevent="handleCancel()">
                                    <a href="#">Close Claims</a>
                                </li>
                            </ul>
                        </span>
                    </div>


                    <div id="displays"></div>
                    <EnrolleeBill :cluster="cluster" :encounter="encounter" @back="handleReview('view')"
                        @next="handleNext" v-if="next" />

                    <div v-else>
                        <SummaryBill :cluster="cluster" :encounters="encounters" :isSubmitting="isSubmitting"
                            :isManual="true" @reload="handleReload" @cancel="handleCancel" />

                     <div class="row" v-if="cluster.status === 'q'">    

                            <!-- Breaker -->
                            <span class="co1 m7"></span>

                            <button class="waves-effect waves-light btn-large btn col s12 m5 right modal-trigger"
                                :class="{
                                    disabled: isSubmitting || encounters.find(x => x.status === 'q') || !encounters.length || lock,
                                }" data-target="confirmSubmit">
                                <i class="medium material-icons left">check_circle</i>{{ isSubmitting ? "Submit" :
                                    "Final Claims Submit"
                                }}
                            </button>
                            <!-- Confirmation -->
                            <Modal id="confirmSubmit" class="modal" :title="alertTitle" :message="alertMessage"
                                @confirm="handleConfirm" v-if="cluster" />

                     </div>

                    </div>
                </div>
            </template>

        </template>

    </div>


</template>


<script>
import { ref, onMounted, onUpdated, computed, watchEffect, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ageSex, capWordsFx, } from "@/composables/fxLibrary/coreFx";
import getItemsOfItemsOfItems from "@/composables/getItemsOfItemsOfItems";
import getItems from "@/composables/getItems";
import putItem from "@/composables/putItem";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import EnrolleeBill from "@/components/billing/EnrolleeBillComponent.vue";
import SummaryBill from "@/components/billing/SummaryBillComponent.vue";
import SubmitSummary from "@/components/claim/SubmitSummaryClaimComponent.vue";
import { getFullMonthName } from "@/composables/fxLibrary/months";
import Modal from "@/components/alerts/ModalComponent.vue";
import { getCachedServerDate } from "@/composables/requestOptimization";
import { HMO } from '@/laravel/config';
import M from "materialize-css";

export default {
    name: "claimsAdd",
    props: ["clusterId", "active"],
    emits: ["menu", "active", "cancel"],
    components: { SubHeading, LoadingDiv, EnrolleeBill, SummaryBill, SubmitSummary, Modal },
    setup(props, context) {
        const lock = ref(true);
        const isManual = ref(false); // toggle manual claims
        const adder = ref(true);
        const serverTime = ref(null);
        const isReady = ref(false);
        const isLoading = ref(false);
        const isSubmitting = ref(false);
        const cluster = ref(null);
        const encounter = ref(null);
        const next = ref(false);
        const error = ref(null);
        const success = ref(null);
        const notifyTitle = ref(null);
        const notifyMessage = ref(null);
        const alertTitle = ref("Confirm");
        const alertMessage = ref("Are you sure you want to submit? Please confirm that all the details provided are accurate. Once submitted, changes cannot be made unless approved by your HMO.");
        const home = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);
        const tabsState = ref([]);
        const currState = ref(null);

        // vue router
        const router = useRouter();

        // store
        const store = useStore();

        // config
        const providerId = store.state?.user?.account?.id;

        // start
        onMounted(() => {
            // page name
            document.title = "View Claims | EasyHMO";
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Billing", title: "Home", icon: "arrow_back", url: "billing", hash: null, });
            tabs.value.push({ id: 2, name: "Billing", title: "Review", icon: null, url: null, hash: null });

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("Review"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("Review"));
        });

        // starter
        onMounted(() => {
            // set current Url
            (async () => {
                const { res, err } = await getItemsOfItemsOfItems("cluster/provider", providerId, props.clusterId);

                if (res.value) {
                    // start
                    let clusterData = res.value.data;
                    // convert month_year
                    let monthYear = res.value.data.month_year.split("_");
                    // month
                    clusterData.month = { search: Number(monthYear[0]), name: getFullMonthName(monthYear[0] - 1) };
                    // year
                    clusterData.year = { search: Number(monthYear[1]), name: monthYear[1] };
                    // uptimize claims
                    clusterData.encounters.forEach((encounter) => {
                        encounter.claims.forEach((claim) => {
                            claim.claim = claim.item
                            claim.qty = claim.sent_qty
                            claim.amt = claim.sent_price
                            claim.standard = claim.standard_price
                        })
                    });
                    // set cluster
                    cluster.value = clusterData;
                } else {
                    error.value = err.value;
                }

                // page is ready, loading is complete
                isReady.value = true;
                isLoading.value = false;
            })();
        });


        // handle cancel
        const handleCancel = () => {
            // clear temp save
            router.push({ name: "billing" });
        }

        // menu
        onMounted(() => {
            (async () => {
                const { res } = await getCachedServerDate(getItems);

                if (res.value) {
                    // current time
                    serverTime.value = res.value.data;
                }

            })();
        });

        // watch serverTime.value
        watchEffect(() => {
            if (serverTime.value) {
                // if (store.state.cluster) {
                if (Number(serverTime.value?.current_month) > Number(cluster.value?.month_year?.split("_")[0]) || Number(serverTime.value?.current_year) > Number(cluster.value?.month_year?.split("_")[1])) {
                    // open lock
                    lock.value = false;
                }
                // }
            }
        })

        // start
        onMounted(() => {
            // load tab
            tabsState.value.push({ id: 1, title: "Summary (All)" });
            tabsState.value.push({ id: 2, title: "Review" });
            // set default
            currState.value = tabsState.value[0];
            // send menu to parent
            context.emit("menu", tabsState.value);
        });

        // change state
        const handleState = (val) => {

            // clear all
            handleClear();

            // set
            if (val) {
                currState.value = val;
                router.push({ hash: "#top" });
            }

        }

        // close notification
        const handleOk = () => {
            // clear notification
            notifyTitle.value = null;
            notifyMessage.value = null;
            // Restore scrollbar (insurance)
            resetScrollBar();
        }

        // more
        onUpdated(() => {
            var elems = document.querySelectorAll(".dropdown-trigger");
            M.Dropdown.init(elems, {});
        });

        // alert
        onMounted(() => {
            // modal
            const elems = document.querySelectorAll(".modal");
            M.Modal.init(elems, {});
        });

        // alert
        onUpdated(() => {
            // modal
            const elems = document.querySelectorAll(".modal");
            M.Modal.init(elems, {});
        });

        //from functions
        const capWords = (val) => {
            return capWordsFx(val);
        };

        // ageSex
        const showAgeSex = (dob, sex) => {
            const { fx } = ageSex(dob, sex);
            return fx.value;
        };

        // scrollbar
        const resetScrollBar = () => {
            // Restore scrollbar (insurance)
            document.body.style.overflow = 'auto';
        }

        // clear all
        const handleClear = () => {
            error.value = null;
            success.value = null;
        }

        // handle curr status
        const handleActive = (tab) => {
            // refer
            if (tab.hash) {
                router.push({ name: tab.url, hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // handle curr status
        const handleActiveState = (tab) => {
            // handle tab
            if (tab) {
                currState.value = tab;
                // send back
                // to parent menu
                context.emit("active", tab);
            }
            // top
            if (currState.value?.title.toLowerCase().includes("summary")) {
                // open summary
                handleReview("view");
                // route top
                router.push({ hash: "#top" });
            } else if (currState.value?.title.toLowerCase().includes("review")) {
                // route display
                router.push({ hash: "#displays" });
            }
        };

        // monitor active
        watch(() => props.active, (newVal) => {
            if (newVal) {
                handleActiveState(newVal);
            }
        });

        // handle next
        const handleNext = async (val) => {

            // clear all 
            // notifications
            handleClear();

            // start
            if (cluster.value && val?.encounter) {

                const encounterIndex = cluster.value.encounters.findIndex(
                    item => Number(item.id) === Number(val.encounter.id),
                );

                if (encounterIndex === -1) {
                    cluster.value.encounters.push(val.encounter);
                } else {
                    cluster.value.encounters[encounterIndex] = val.encounter;
                }

                // filter
                cluster.value.encounters.filter(x => x.status !== "d");
                // save payload
                // store.commit("loadCluster", cluster.value);

            }

            // if submit
            if (val.submit) {
                // close encounter
                encounter.value = null;
                // close enrolleeClaim
                next.value = false;
                // set default
                currState.value = tabsState.value?.find(x => x.title.toLowerCase().includes("summary"));
                // scroll up
                router.push({ hash: "#displays" });
            }

        };

        // handle reload
        const handleReload = (val) => {
            encounter.value = val.encounter;
            // editId.value = val.encounter.editId;
            next.value = true;
            // set default
            currState.value = tabsState.value?.find(x => x.title.toLowerCase().includes("review"));
            // to parent menu
            context.emit("active", currState.value);
            // scroll up
            router.push({ hash: "#top" });
        };

        // handle review
        const handleReview = (val) => {
            if (val == "view") {
                next.value = false;
                // reset default
                currState.value = tabsState.value[0];
                // to parent menu
                context.emit("active", currState.value);
                // go up
                router.push({ hash: "#top" });
            } else if (val == "add") {
                next.value = true;
            }
        };

        // download
        const handleDownload = () => {
            // nothing, just back home
            console.log("download");
        }

        // confirmation
        const handleConfirm = (val) => {
            // call submit if confirmed
            if (val) {
                // p = submitted
                handleSubmit("p");
            } else {
                // Restore scrollbar (insurance)
                resetScrollBar();
            }
        }

        // handle review
        const handleSubmit = async (clusterStatusVal) => {

            // check first
            if (!encounters.value.find(x => x.status === 'q')) {

                // clear all 
                // notifications
                handleClear();

                // start
                isSubmitting.value = true;
                // clear error
                error.value = null;

                // go
                const { res } = await putItem("cluster", cluster.value.id, {
                    status: clusterStatusVal,
                });


                if (res.value) {

                    // next action
                    if (res.value.data.status === "q") {

                        // nothing, just back home
                        handleState("c"); // c=current, u=user, h=hmo, n=null

                        // clear
                        cluster.value = null;


                    } else {

                        if (res.value.data.status === "p") {
                            // load success cluster
                            // res.value.data.month = cluster.value.month.name;
                            // res.value.data.year = cluster.value.year.name;
                            // res.value.data.scheme = cluster.value.scheme;

                            //load cluster
                            cluster.value.status = res.value.data.status;

                            // filter
                            cluster.value.encounters.filter(x => x.status !== "d");

                            // save payload
                            //   store.commit("loadCluster", cluster.value);

                            // reset
                            handleState("c"); // c=current, u=user, h=hmo, n=null

                        } else {
                            // nothing, just back home
                            handleState("c"); // c=current, u=user, h=hmo, n=null
                        }

                    }

                } else {
                    error.value = "Sorry, Something went wrong!";
                }

                // Restore scrollbar (insurance)
                resetScrollBar();

                // end
                isSubmitting.value = false; // in case of incasecity!

            }

        };

        // output claims results
        const encounters = computed(() => {
            if (!("encounters" in cluster.value)) {
                return [];
            } else {
                return cluster.value.encounters;
            }
        });

        return {
            lock,
            isManual,
            adder,
            handleCancel,
            handleActive,
            handleActiveState,
            handleDownload,
            home,
            currTab,
            tabs,
            tabsState,
            currState,
            capWords,
            showAgeSex,
            handleOk,
            handleClear,
            handleState,
            handleConfirm,
            handleReview,
            handleNext,
            handleReload,
            handleSubmit,
            notifyTitle,
            notifyMessage,
            alertTitle,
            alertMessage,
            success,
            error,
            isReady,
            isSubmitting,
            next,
            cluster,
            encounter,
            encounters,
            HMO: HMO,
        };
    },
};
</script>

<style scoped>
.progress {
    margin-top: -15px;
}

.clickable {
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.clickable:hover {
    opacity: 0.8;
}

.pointable {
    cursor: default;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.pointable:hover {
    opacity: 0.8;
}

.spacer {
    padding: 2px;
}

.pointer {
    cursor: default;
}

@media only screen and (max-width: 600px) {
    .card,
    .card-panel {
        border-radius: 6px;
        box-shadow: none;
    }

    .card-content,
    .card-panel {
        padding: 16px;
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    .col {
        padding-left: 0;
        padding-right: 0;
        width: 100% !important;
    }

    .btn,
    .btn-large,
    .btn-floating {
        float: none !important;
        margin-bottom: 8px;
        width: 100%;
    }

    .responsive-table {
        overflow-x: auto;
    }

    table {
        min-width: 680px;
    }
}
</style>
